import { useRef, useEffect, useState } from 'react';
import * as motion from 'framer-motion/client';
// import { useTransform, useScroll, useInView } from 'framer-motion';
import { useInView } from 'framer-motion';
import styles from './video.module.scss';
import classNames from 'classnames';
import Image from 'next/image';
import uikit from '../../../project/uikit/uikit.module.scss';
import { svgSprite } from '../../../hybrid/wrappers';

const VideoPage = () => {
    const sectionRef = useRef();
    const isInView = useInView(sectionRef, { amount: 0.5 });
    const videoRef = useRef(null);

    const [isVideoActive, setIsVideoActive] = useState(false);
    const [videoSrc, setVideoSrc] = useState('');
    const [posterSrc, setPosterSrc] = useState('');

    useEffect(() => {
        if (!isInView) {
            setIsVideoActive(false);
            setVideoSrc('');
            setPosterSrc('');
        }
    }, [isInView]);

    useEffect(() => {
        if (isVideoActive && videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.error('Cant autoplay', error);
            });
        } else if (videoRef.current) {
            videoRef.current.pause();
        }
    }, [isVideoActive]);

    // Обработчик для клика на видео-контейнер
    const handleVideoClick = (video, poster) => {
        setVideoSrc(video);
        setPosterSrc(poster);
        setIsVideoActive(true);
    };

    // Обработчик для закрытия видео
    const handleCloseVideo = () => {
        setIsVideoActive(false);
    };

    return (
        <div className={styles.videoSectionWrapper}>
            <div className={styles.stickyContainer} ref={sectionRef}>
                <div className={`${styles.videoPageWrapper} ${isVideoActive ? styles.videoActive : ''}`}>
                    <motion.div className={styles.videoPageWrapperInner}>
                        <motion.div
                            className={classNames(styles.rowWrapper, styles.rowWrapper01)}
                            // style={{
                            //     transform: !isInView ? 'translateX(100px)' : 'translateX(0px)',
                            //     transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s',
                            //     position: 'relative',
                            //     zIndex: 1
                            // }}
                        >
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7656.mp4'}
                                data-poster={'/src/landing/video/vid1.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7656.mp4', '/src/landing/video/vid1.png')}
                            >
                                <Image src='/src/landing/video/vid1.png' fill alt={'vid1-img'} />
                            </motion.div>

                            <p>business</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7661.mp4'}
                                data-poster={'/src/landing/video/vid2.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7661.mp4', '/src/landing/video/vid2.png')}
                            >
                                <Image src='/src/landing/video/vid2.png' fill alt={'vid2-img'} />
                            </motion.div>

                            <p>world</p>

                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7640.mp4'}
                                data-poster={'/src/landing/video/vid3.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7640.mp4', '/src/landing/video/vid3.png')}
                            >
                                <Image src='/src/landing/video/vid3.png' fill alt={'vid3-img'} />
                            </motion.div>

                            <p>mission</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7648.mp4'}
                                data-poster={'/src/landing/video/vid4.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7648.mp4', '/src/landing/video/vid4.png')}
                            >
                                <Image src='/src/landing/video/vid4.png' fill alt={'vid4-img'} />
                            </motion.div>

                            <p>way</p>
                        </motion.div>
                        <motion.div
                            className={classNames(styles.rowWrapper, styles.rowWrapperMain, styles.rowWrapper02)}
                            // style={
                            //     width > 767
                            //         ? {
                            //               transform: !isInView ? 'none' : 'translateX(100px)',
                            //               transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s',
                            //               position: 'relative',
                            //               zIndex: 1
                            //           }
                            //         : {}
                            // }
                        >
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7650.mp4'}
                                data-poster={'/src/landing/video/vid15.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7650.mp4', '/src/landing/video/vid15.png')
                                }
                            >
                                <Image src='/src/landing/video/vid15.png' fill alt={'vid15-img'} />
                            </motion.div>
                            <p>life</p>

                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7653.mp4'}
                                data-poster={'/src/landing/video/vid5.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7653.mp4', '/src/landing/video/vid5.png')}
                            >
                                <Image src='/src/landing/video/vid5.png' fill alt={'vid5-img'} />
                            </motion.div>

                            <p>global</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7665.mp4'}
                                data-poster={'/src/landing/video/vid6.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7665.mp4', '/src/landing/video/vid6.png')}
                            >
                                <Image src='/src/landing/video/vid6.png' fill alt={'vid6-img'} />
                            </motion.div>

                            <p>trend</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7644.mp4'}
                                data-poster={'/src/landing/video/vid7.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7644.mp4', '/src/landing/video/vid7.png')}
                            >
                                <Image src='/src/landing/video/vid7.png' fill alt={'vid7-img'} />
                            </motion.div>

                            <p>luxury</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7634.mp4'}
                                data-poster={'/src/landing/video/vid8.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7634.mp4', '/src/landing/video/vid8.png')}
                            >
                                <Image src='/src/landing/video/vid8.png' fill alt={'vid8-img'} />
                            </motion.div>

                            <p>brand</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7642.mp4'}
                                data-poster={'/src/landing/video/vid9.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7642.mp4', '/src/landing/video/vid2.png')}
                            >
                                <Image src='/src/landing/video/vid9.png' fill alt={'vid9-img'} />
                            </motion.div>

                            <p>quality</p>
                        </motion.div>
                        <motion.div
                            className={classNames(styles.rowWrapper, styles.rowWrapper03)}
                            // style={
                            //     width > 767
                            //         ? {
                            //               transform: !isInView ? 'none' : 'translateX(-100px)',
                            //               transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s',
                            //               position: 'relative',
                            //               zIndex: 1
                            //           }
                            //         : {}
                            // }
                        >
                            <p>posibilities</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7660.mp4'}
                                data-poster={'/src/landing/video/vid10.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7660.mp4', '/src/landing/video/vid10.png')
                                }
                            >
                                <Image src='/src/landing/video/vid10.png' fill alt={'vid10-img'} />
                            </motion.div>
                            <p>health</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7613.mp4'}
                                data-poster={'/src/landing/video/vid11.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7613.mp4', '/src/landing/video/vid11.png')
                                }
                            >
                                <Image src='/src/landing/video/vid11.png' fill alt={'vid11-img'} />
                            </motion.div>

                            <p>beauty</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7663.mp4'}
                                data-poster={'/src/landing/video/vid12.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7663.mp4', '/src/landing/video/vid12.png')
                                }
                            >
                                <Image src='/src/landing/video/vid12.png' fill alt={'vid12-img'} />
                            </motion.div>

                            <p>perfect</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7159.mp4'}
                                data-poster={'/src/landing/video/vid13.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7159.mp4', '/src/landing/video/vid13.png')
                                }
                            >
                                <Image src='/src/landing/video/vid13.png' fill alt={'vid13-img'} />
                            </motion.div>
                            <p>product</p>
                        </motion.div>
                        <motion.div
                            className={classNames(styles.rowWrapper, styles.rowWrapperIndex, styles.rowWrapper04)}
                            // style={
                            //     width > 767
                            //         ? {
                            //               transform: !isInView ? 'none' : 'translateX(100px)',
                            //               transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s',
                            //               position: 'relative',
                            //               zIndex: 1
                            //           }
                            //         : {}
                            // }
                        >
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7616.mp4'}
                                data-poster={'/src/landing/video/vid9.png'}
                                onClick={() => handleVideoClick('/src/landing/video/IMG_7616.mp4', '/src/landing/video/vid9.png')}
                            >
                                <Image src='/src/landing/video/vid9.png' fill alt={'vid19-img'} />
                            </motion.div>
                            <p>style</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7655.mp4'}
                                data-poster={'/src/landing/video/vid14.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7655.mp4', '/src/landing/video/vid14.png')
                                }
                            >
                                <Image src='/src/landing/video/vid14.png' fill alt={'vid14-img'} />
                            </motion.div>
                            <p>growth</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7610.mp4'}
                                data-poster={'/src/landing/video/vid15.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7610.mp4', '/src/landing/video/vid15.png')
                                }
                            >
                                <Image src='/src/landing/video/vid15.png' fill alt={'vid15-img'} />
                            </motion.div>
                            <p>leaders</p>

                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7659.mp4'}
                                data-poster={'/src/landing/video/vid16.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7659.mp4', '/src/landing/video/vid16.png')
                                }
                            >
                                <Image src='/src/landing/video/vid16.png' fill alt={'vid16-img'} />
                            </motion.div>
                            <p>strength</p>
                            <motion.div
                                className={styles.videoContainer}
                                data-video={'/src/landing/video/IMG_7567.mp4'}
                                data-poster={'/src/landing/video/vid17.png'}
                                onClick={() =>
                                    handleVideoClick('/src/landing/video/IMG_7567.mp4', '/src/landing/video/vid17.png')
                                }
                            >
                                <Image src='/src/landing/video/vid17.png' fill alt={'vid17-img'} />
                            </motion.div>
                            <p>happiness</p>
                        </motion.div>
                    </motion.div>
                    <>
                        <motion.div className={styles.underVideoHide} />
                        <div className={styles.underVideo}>
                            <motion.video
                                ref={videoRef}
                                src={videoSrc}
                                poster={posterSrc}
                                autoPlay
                                loop
                                //muted
                                preload='none'
                                playsInline
                                style={{
                                    width: '100%',
                                    height: '100vh',
                                    objectFit: 'cover'
                                }}
                                // initial={{ clipPath: 'circle(0% at 50% 50%)' }}
                                // animate={isInView ? { clipPath: 'circle(100% at 50% 50%)' } : {}}
                                // transition={{ duration: 2, delay: 0.5 }}
                                className={styles.videoPlayer}
                            />
                        </div>
                        <div className={styles.videoCloseWrapper}>
                            <div className={uikit.container}>
                                <div className={styles.videoClose} onClick={handleCloseVideo}>
                                    {svgSprite('cross', {
                                        fill: 'currentColor',
                                        className: styles.videoCloseSvg
                                    })}
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
};
export default VideoPage;
